export default "__VITE_ASSET__c5efd173__"